import { AttendanceCustomTimeRangeDayEnum as DayEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const translateDayInSingular = (day: DayEnum) => {
  switch (day) {
    case 'monday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.monday')
    case 'tuesday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.tuesday')
    case 'wednesday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.wednesday')
    case 'thursday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.thursday')
    case 'friday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.friday')
    case 'saturday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.saturday')
    case 'sunday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.sunday')
    case 'bank_holiday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.bank_holiday')
    default:
      const exhaustiveCheck: never = day
      throw new Error(`Unhandled day: ${exhaustiveCheck}`)
  }
}

export const translateDayInPlural = (day: DayEnum) => {
  switch (day) {
    case 'monday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.mondays')
    case 'tuesday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.tuesdays')
    case 'wednesday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.wednesdays')
    case 'thursday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.thursdays')
    case 'friday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.fridays')
    case 'saturday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.saturdays')
    case 'sunday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.sundays')
    case 'bank_holiday':
      return i18n.t('time_tracking.settings.custom_time_range_section.days.bank_holidays')
    default:
      const exhaustiveCheck: never = day
      throw new Error(`Unhandled day: ${exhaustiveCheck}`)
  }
}
